var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterSingleChip',{attrs:{"is-text":"","label-mode":_vm.labelMode,"icon":"file-text","label":_vm.$t('search-filters.documents'),"items":_vm.items,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }